import axios from "axios";
import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Config from "../../../../Config";
import {
  color_grey_dark,
  color_red_default,
  color_transparent,
  color_white,
} from "../../../../constants/colors";
import { getMyId } from "../../../../pages/personal/PersonalPage";
import { updateUser } from "../../../../store/UserSlice";
import { validatePhone } from "../../../../utilities/validatePhone";
import { useWindowDimensions } from "../../../../utils";
import { LoadingContainer } from "../../../containers/LoadingContainer";
import { Button } from "../../../controls/Button/Button";
import { FormPhoneInput } from "../../../inputs/FormTextInput/FormPhoneInput";
import { NewFormTextInput } from "../../../inputs/FormTextInput/FormTextInput";
import TimezoneSelect from "react-timezone-select";
import {
  OnestNormalSmall
} from "../../../styled/TextComponents";
import ModalSimple from "../../ModalSimple";
import { styles } from "./Styles";
import {
  timezoneLabelsWithCountries,
  timezoneOptionsSorted,
  filterTimezoneOption,
} from "./timezoneConfig";
import { useI18n } from "../../../../i18n/I18nProvider";

export { get_user } from "../../../../api/user";

export const ProfileDataUpdatingBlock = ({ onRequestClose }) => {
  const { t } = useI18n();
  const { height: screenHeight, width: screenWidth } = useWindowDimensions();

  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const [timeZone, setTimeZone] = useState(
    user?.time_zone || Intl.DateTimeFormat().resolvedOptions().timeZone,
  );

  const [isLoading, setIsLoading] = useState(false);
  const [isNeedUpdate, setIsNeedUpdate] = useState(false);
  const [name, setName] = useState(user?.name || "");
  const [phone, setPhone] = useState(user?.phoneNumber || "");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordRepeat, setNewPasswordRepeat] = useState("");
  const [isPhoneModalOpen, setIsPhoneModalOpen] = useState(false);
  const [phoneModalText, setPhoneModalText] = useState("");
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const handleNameChange = useCallback(
    (e) => {
      setName(e.target.value);
      setIsNeedUpdate(true);
    },
    [name],
  );

  const handlePhoneChange = useCallback(
    (e) => {
      setPhone(e.target.value);
      setIsNeedUpdate(true);
    },
    [phone],
  );

  const handleTimeZoneChange = useCallback((tz) => {
    setTimeZone(typeof tz === "object" && tz?.value ? tz.value : tz);
    setIsNeedUpdate(true);
  }, []);

  const handleNewPasswordChange = useCallback(
    (e) => {
      setNewPassword(e.target.value);
      setIsNeedUpdate(true);
    },
    [newPassword],
  );

  const handleNewPasswordRepeatChange = useCallback(
    (e) => {
      setNewPasswordRepeat(e.target.value);
      setIsNeedUpdate(true);
    },
    [newPasswordRepeat],
  );

  function uploadNewData() {
    const phoneValidation = validatePhone(phone);
    if (!phoneValidation.valid) {
      setPhoneModalText(t(
        phoneValidation.error ||
          "Введите корректный номер телефона (10–15 цифр)",
      ));
      setIsPhoneModalOpen(true);
      return;
    }
    setIsLoading(true);

    let oldState = { ...user };
    dispatch(
      updateUser({
        name: name,
        image: user.image,
        phoneNumber: phone,
        time_zone: timeZone,
      }),
    );
    getMyId()
      .then((id) => {
        let requestData = {
          full_name: name,
          image: user.image,
          phone_number: phone,
          time_zone: timeZone,
        };
        /* 
            if (newPassword.length > 0) {
                requestData.password = newPassword
            }
*/
        axios
          .patch(Config.BACKEND_ADDR + `/auth/user/${id}`, requestData)
          .then((response) => {
            setIsNeedUpdate(false);
            console.log("RESPONSE", response);
            setIsSuccessModalOpen(true);
          })
          .catch(() => {
            alert(t("Ошибка обновления данных"));
            dispatch(updateUser(oldState));
          });
      })
      .catch(() => {
        alert(t("Ошибка обновления данных"));
        dispatch(updateUser(oldState));
      });
    setIsLoading(false);
  }

  return (
    <div
      style={{
        ...styles.dataUpdatingContainer,
        width: screenWidth >= 768 ? 530 : 320,
      }}
    >
      <LoadingContainer isLoading={isLoading}>
        <div width="100%" style={styles.dataUpdatingForm}>
          <NewFormTextInput
            placeholder={t("Введите имя")}
            type={"text"}
            title={t("Имя")}
            value={name}
            width={screenWidth >= 768 ? 475 : 265}
            onChange={handleNameChange}
          />
          <FormPhoneInput
            placeholder={user.phoneNumber}
            type={"tel"}
            title={t("Номер телефона")}
            value={phone}
            width={screenWidth >= 768 ? 475 : 265}
            onChange={handlePhoneChange}
          />

          <div
            style={{
              display: "inline-flex",
              flexDirection: "column",
              alignItems: "flex-start",
              width: screenWidth >= 768 ? 475 : 265,
              gap: 10,
              fontSize: 14,
            }}
          >
            <OnestNormalSmall>{t("Часовой пояс")}</OnestNormalSmall>
            <div style={{ width: "100%" }}>
              <TimezoneSelect
                value={timeZone}
                onChange={handleTimeZoneChange}
                displayValue="UTC"
                timezones={timezoneLabelsWithCountries}
                options={timezoneOptionsSorted}
                filterOption={filterTimezoneOption}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{
                control: (base) => ({
                  ...base,
                  minHeight: 50,
                  borderRadius: 5,
                  border: "1px solid transparent",
                  backgroundColor: "#F5F5F5",
                  fontFamily: "Onest",
                  fontSize: 16,
                }),
                menu: (base) => ({
                  ...base,
                  fontFamily: "Onest",
                  fontSize: 16,
                  zIndex: 9999,
                }),
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              />
            </div>
          </div>

          {/* 
                        <NewFormTextInput 
                            placeholder={"Введите новый пароль"} 
                            type={"password"} 
                            title={"Введите новый пароль"} 
                            value={newPassword} 
                            onChange={handleNewPasswordChange} 
                        />
                        <NewFormTextInput 
                            placeholder={"Повторите новый пароль"} 
                            type={"password"} 
                            title={"Повторите новый пароль"} 
                            value={newPasswordRepeat} 
                            onChange={handleNewPasswordRepeatChange} 
                        />
                         */}
          <Button
            outline={false}
            type="submit"
            width={screenWidth >= 768 ? 475 : 265}
            height={60}
            backgroundColor={isNeedUpdate ? color_red_default : color_grey_dark}
            color={color_white}
            borderColor={color_transparent}
            fontSize={18}
            disabled={!isNeedUpdate}
            onClick={uploadNewData}
          >
            {t("Сохранить")}
          </Button>
        </div>
      </LoadingContainer> 
      <ModalSimple
        type="error"
        h2={t("Некорректный номер")}
        p={phoneModalText}
        isOpen={isPhoneModalOpen}
        onClose={() => setIsPhoneModalOpen(false)}
        buttonText={t("Закрыть")}
      />
      <ModalSimple
        type="success"
        h2={t("Данные успешно обновлены")}
        isOpen={isSuccessModalOpen}
        onClose={() => {
          setIsSuccessModalOpen(false);
          onRequestClose();
        }}
        buttonText={t("Закрыть")}
      />
    </div>
  );
};
